import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";
import { formatToCommaSeparatedString } from "utils/HelperFunctions";

function getPrivateReleaseText(magnetPrice: number) {
  if (magnetPrice > 0) {
    return `The price of Magnet in this release is ${formatToCommaSeparatedString(
      magnetPrice,
      "currency",
    )}. Only $0 magnets can be released Privately. By making this release 'Private', the price will be automatically set to $0. If this option is enabled this release will be accessible to users only through the claim page of this release. Do you want to make this release 'Private' ?`;
  }
  return "If this option is enabled this release will be accessible to users only through the claim page of this release. Do you want to make this release 'Private' ?";
}
interface IProps {
  open: boolean;
  onClose: () => void;
  handlePrivateReleaseChange: (isReleasePrivate: boolean) => void;
  isPrivateRelease: boolean;
  magnetPrice: number;
}
function PrivateReleaseModal({
  open = false,
  onClose,
  handlePrivateReleaseChange,
  isPrivateRelease,
  magnetPrice,
}: IProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative rounded-2xl bg-primary p-8 text-white shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-2xl font-bold leading-tight">
              {isPrivateRelease ? "Stop Private Release:" : "Make Release Private:"}
            </h1>
          </div>

          <button type="button" onClick={onClose} className="p-3">
            <CloseIcon className="h-4 w-4 text-white" />
          </button>
        </div>
        <section className="mt-3 w-full font-satoshi text-sm font-450 leading-snug text-white text-opacity-70">
          {isPrivateRelease
            ? "This release will be accessible to users only through the claim page. You can stop private release to make it accessible to everyone through the platform. Do you want to stop private release?"
            : getPrivateReleaseText(magnetPrice)}
        </section>
        <div className="mt-10 flex justify-end gap-3">
          <Button variant="whiteOutline" text="CANCEL" onClick={onClose} additionalClasses="text-xs" />
          <Button
            variant={isPrivateRelease ? "rustPinkSolid" : "magnetiqSolid"}
            text={isPrivateRelease ? "STOP PRIVATE RELEASE" : "MAKE PRIVATE"}
            onClick={() => handlePrivateReleaseChange(!isPrivateRelease)}
            additionalClasses="text-xs"
          />
        </div>
      </div>
    </Modal>
  );
}

export default PrivateReleaseModal;
